import request from "@/utils/request";

//获取首页数据
export const getHomeData = () => {
  return request.get("/page/detail", {
    params: {
      pageId: 0,
    },
  });
};
// export function getHomeBanner(data) {
//   return request.get({
//     url: '/api/mts-api/banner/list',
//     method: 'post',
//     data: data
//   })
// }

// 公共布局与首页可能同时读取同一组横幅；仅合并在途请求，不缓存已完成的数据。
const pendingBannerRequests = new Map();
export const getBannerAdv = (params = {}) => {
  const query = Object.fromEntries(
    Object.keys(params).sort().filter((key) => params[key] != null)
      .map((key) => [key, params[key]])
  );
  const key = JSON.stringify(query);
  let pending = pendingBannerRequests.get(key);
  if (!pending) {
    pending = Promise.resolve().then(() => request.get("/api/mts-api/banner/list", {
      params: query,
      // 横幅属于公开数据，登录失效时不主动弹出登录框。
      skipAuthRedirect: true,
    })).finally(() => pendingBannerRequests.delete(key));
    pendingBannerRequests.set(key, pending);
  }
  // 各组件仍可独立排序、过滤，避免共享同一个响应对象而互相影响。
  return pending.then((response) => response == null ? response : JSON.parse(JSON.stringify(response)));
};
export const getHomeBanner = () => getBannerAdv({
  which: 2,
  type: 2,
  position: "HOME",
  status: 0,
});

export const getNavList = (params) => {
  return request.get("/api/mts-api/nav/list", { params });
};

export const getHomeNav = (params) => {
  return request.get("/api/mts-api/nav/list", { params });
};

export const getHomeGoods = (params) => {
  return request.get("/api/mts-api/recGoods/list", { params, skipAuthRedirect: true, skipErrorMessage: true });
};

export const getGoods = (params) => {
  return request.get("/api/mts-api/goods/list", { params });
};

export const getHomeClue = (params) => {
  return request.get("/api/mts-api/clue/clueList", { params });
};

// 精选信息审核能力由后台业务组决定，不能从列表供应商标志推断。
export const getClueCapabilities = () => request.get("/api/mts-api/clue/capabilities");
